// Original vocabulary. Role tags constrain where a noun may be used.
export default [
  {
    "id": "cookie",
    "role": "countable",
    "singular": "cookie",
    "plural": "cookies",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "muffin",
    "role": "countable",
    "singular": "muffin",
    "plural": "muffins",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "apple",
    "role": "countable",
    "singular": "apple",
    "plural": "apples",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "carrot",
    "role": "countable",
    "singular": "carrot",
    "plural": "carrots",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "spoon",
    "role": "countable",
    "singular": "spoon",
    "plural": "spoons",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "fork",
    "role": "countable",
    "singular": "fork",
    "plural": "forks",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "plate",
    "role": "countable",
    "singular": "plate",
    "plural": "plates",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "napkin",
    "role": "countable",
    "singular": "napkin",
    "plural": "napkins",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "cupcake",
    "role": "countable",
    "singular": "cupcake",
    "plural": "cupcakes",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "cracker",
    "role": "countable",
    "singular": "cracker",
    "plural": "crackers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ribbon",
    "role": "measurable",
    "singular": "ribbon",
    "plural": "ribbons",
    "tags": [
      "length"
    ]
  },
  {
    "id": "string",
    "role": "measurable",
    "singular": "string",
    "plural": "strings",
    "tags": [
      "length"
    ]
  },
  {
    "id": "water",
    "role": "measurable",
    "singular": "water",
    "plural": "waters",
    "tags": [
      "liquid"
    ]
  },
  {
    "id": "milk",
    "role": "measurable",
    "singular": "milk",
    "plural": "milks",
    "tags": [
      "liquid"
    ]
  },
  {
    "id": "bowl",
    "role": "container",
    "singular": "bowl",
    "plural": "bowls",
    "tags": []
  },
  {
    "id": "basket",
    "role": "container",
    "singular": "basket",
    "plural": "baskets",
    "tags": []
  },
  {
    "id": "box",
    "role": "container",
    "singular": "box",
    "plural": "boxes",
    "tags": []
  },
  {
    "id": "tray",
    "role": "container",
    "singular": "tray",
    "plural": "trays",
    "tags": []
  },
  {
    "id": "cook",
    "role": "person",
    "singular": "cook",
    "plural": "cooks",
    "tags": []
  },
  {
    "id": "baker",
    "role": "person",
    "singular": "baker",
    "plural": "bakers",
    "tags": []
  },
  {
    "id": "helper",
    "role": "person",
    "singular": "helper",
    "plural": "helpers",
    "tags": []
  },
  {
    "id": "guest",
    "role": "person",
    "singular": "guest",
    "plural": "guests",
    "tags": []
  },
  {
    "id": "cooking-lesson",
    "role": "action",
    "singular": "cooking lesson",
    "plural": "cooking lessons",
    "tags": []
  },
  {
    "id": "baking-session",
    "role": "action",
    "singular": "baking session",
    "plural": "baking sessions",
    "tags": []
  },
  {
    "id": "meal",
    "role": "action",
    "singular": "meal",
    "plural": "meals",
    "tags": []
  },
  {
    "id": "taste-test",
    "role": "action",
    "singular": "taste test",
    "plural": "taste tests",
    "tags": []
  },
  {
    "id": "oven",
    "role": "structure",
    "singular": "oven",
    "plural": "ovens",
    "tags": []
  },
  {
    "id": "workbench",
    "role": "structure",
    "singular": "workbench",
    "plural": "workbenches",
    "tags": []
  },
  {
    "id": "kitchen",
    "role": "place",
    "singular": "kitchen",
    "plural": "kitchens",
    "tags": []
  },
  {
    "id": "bakery",
    "role": "place",
    "singular": "bakery",
    "plural": "bakeries",
    "tags": []
  }
];
